/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterState } from './barterState.model';
import { SubjectMinimalDto } from './subjectMinimalDto.model';
import { BarterParcelAcreageDo } from './barterParcelAcreageDo.model';
import { BarterParcelDo } from './barterParcelDo.model';
import { MonthYearUnit } from './monthYearUnit.model';
import { BarterParcelGeometryDto } from './barterParcelGeometryDto.model';
import { VersionType } from './versionType.model';


export interface BarterRequestDto { 
    appendixNumber?: number;
    barterNumber?: number;
    barterNumberFormat?: string;
    barterYear?: number;
    concernedParcelAcreages: Array<BarterParcelAcreageDo>;
    concernedParcels: Array<BarterParcelDo>;
    concernedSubject: SubjectMinimalDto;
    counterparty: SubjectMinimalDto;
    counterpartyParcelAcreages: Array<BarterParcelAcreageDo>;
    counterpartyParcels: Array<BarterParcelDo>;
    durationMonths: number;
    durationMonthsUnit: MonthYearUnit;
    durationToDate?: string;
    efficiencyFromDate: string;
    endDate?: string;
    endType?: string;
    expirationDate?: string;
    furtherRentPossible: boolean;
    groupId?: number;
    id?: number;
    incomingAmount: number;
    incomingPayoutDate?: string;
    indefinite: boolean;
    note?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    outgoingAmount: number;
    outgoingPayoutDate: string;
    passedParcelAcreages: Array<BarterParcelAcreageDo>;
    passedParcelGeometries: Array<BarterParcelGeometryDto>;
    passedParcels: Array<BarterParcelDo>;
    paymentsFromEconomicYear?: boolean;
    previousVersionId?: number;
    receivedParcelAcreages: Array<BarterParcelAcreageDo>;
    receivedParcelGeometries: Array<BarterParcelGeometryDto>;
    receivedParcels: Array<BarterParcelDo>;
    resignDate?: string;
    reusedPreviousExpiration?: boolean;
    state?: BarterState;
    toEconomicYear?: boolean;
    versionType?: VersionType;
}
export namespace BarterRequestDto {
}


